/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BranchDto } from './BranchDto';
import {
    BranchDtoFromJSON,
    BranchDtoFromJSONTyped,
    BranchDtoToJSON,
    BranchDtoToJSONTyped,
} from './BranchDto';

/**
 * 
 * @export
 * @interface PracticeProfileViewDto
 */
export interface PracticeProfileViewDto {
    /**
     * Practice ID (Firebase UID)
     * @type {string}
     * @memberof PracticeProfileViewDto
     */
    id: string;
    /**
     * Practice name
     * @type {string}
     * @memberof PracticeProfileViewDto
     */
    practiceName: string;
    /**
     * Practice email
     * @type {string}
     * @memberof PracticeProfileViewDto
     */
    email: string;
    /**
     * Practice phone number
     * @type {string}
     * @memberof PracticeProfileViewDto
     */
    phoneNumber: string;
    /**
     * Phone dial code (e.g. +1)
     * @type {string}
     * @memberof PracticeProfileViewDto
     */
    phoneNumberCountryCode?: string;
    /**
     * Phone country ISO alpha-2 code (e.g. US)
     * @type {string}
     * @memberof PracticeProfileViewDto
     */
    phoneNumberCountryIso2?: string;
    /**
     * Practice fax number
     * @type {string}
     * @memberof PracticeProfileViewDto
     */
    faxNumber?: string;
    /**
     * Array of branch information
     * @type {Array<BranchDto>}
     * @memberof PracticeProfileViewDto
     */
    branches: Array<BranchDto>;
    /**
     * Practice logo URL
     * @type {string}
     * @memberof PracticeProfileViewDto
     */
    logo?: string;
    /**
     * Practice logo/profile picture URL (deprecated, use logo)
     * @type {string}
     * @memberof PracticeProfileViewDto
     */
    profilePicture?: string;
    /**
     * Practice ID (UUID)
     * @type {string}
     * @memberof PracticeProfileViewDto
     */
    practiceId?: string;
}

/**
 * Check if a given object implements the PracticeProfileViewDto interface.
 */
export function instanceOfPracticeProfileViewDto(value: object): value is PracticeProfileViewDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('practiceName' in value) || value['practiceName'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('phoneNumber' in value) || value['phoneNumber'] === undefined) return false;
    if (!('branches' in value) || value['branches'] === undefined) return false;
    return true;
}

export function PracticeProfileViewDtoFromJSON(json: any): PracticeProfileViewDto {
    return PracticeProfileViewDtoFromJSONTyped(json, false);
}

export function PracticeProfileViewDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PracticeProfileViewDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'practiceName': json['practiceName'],
        'email': json['email'],
        'phoneNumber': json['phoneNumber'],
        'phoneNumberCountryCode': json['phoneNumberCountryCode'] == null ? undefined : json['phoneNumberCountryCode'],
        'phoneNumberCountryIso2': json['phoneNumberCountryIso2'] == null ? undefined : json['phoneNumberCountryIso2'],
        'faxNumber': json['faxNumber'] == null ? undefined : json['faxNumber'],
        'branches': ((json['branches'] as Array<any>).map(BranchDtoFromJSON)),
        'logo': json['logo'] == null ? undefined : json['logo'],
        'profilePicture': json['profilePicture'] == null ? undefined : json['profilePicture'],
        'practiceId': json['practiceId'] == null ? undefined : json['practiceId'],
    };
}

export function PracticeProfileViewDtoToJSON(json: any): PracticeProfileViewDto {
    return PracticeProfileViewDtoToJSONTyped(json, false);
}

export function PracticeProfileViewDtoToJSONTyped(value?: PracticeProfileViewDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'practiceName': value['practiceName'],
        'email': value['email'],
        'phoneNumber': value['phoneNumber'],
        'phoneNumberCountryCode': value['phoneNumberCountryCode'],
        'phoneNumberCountryIso2': value['phoneNumberCountryIso2'],
        'faxNumber': value['faxNumber'],
        'branches': ((value['branches'] as Array<any>).map(BranchDtoToJSON)),
        'logo': value['logo'],
        'profilePicture': value['profilePicture'],
        'practiceId': value['practiceId'],
    };
}

